export const PATH_LOGIN = `/login`;

export enum pathsLogin {
  PhoneLogin = '/',
  PhoneConfirm = '/confirm_phone',
}

export const PATH_LOGIN_STEP_1 = PATH_LOGIN;
export const PATH_LOGIN_STEP_2 = `${PATH_LOGIN}${pathsLogin.PhoneConfirm}`;
